import React from 'react';
import './App.css';
import { RouterProvider } from 'react-router-dom'
import router from "./router"
import { ConfigProvider, App as AntdApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { setModalInstance, setNotificationInstance } from './utils/errorHandler'

function GlobalSetup() {
    const { modal, notification } = AntdApp.useApp()
    React.useEffect(() => {
        setModalInstance(modal)
        setNotificationInstance(notification)
    }, [modal, notification])
    return null
}

function App() {
    return (
        <ConfigProvider locale={zhCN}>
            <AntdApp>
                <GlobalSetup />
                <div className="app-container">
                    <RouterProvider router={router} future={{ v7_startTransition: true }} />
                </div>
            </AntdApp>
        </ConfigProvider>
    );
}

export default App;
